import type { FunctionItem, FunctionCodes } from '@/types';

export const functions: FunctionItem[] = [
  {
    id: 'clip-mask',
    name: '裁剪遮罩图片',
    description: '基于鼠标位置动态裁剪图片的交互式遮罩效果',
    preview: 'clip-mask',
  },
  {
    id: 'knob',
    name: '旋钮效果',
    description: '基于鼠标位置动态旋转图片的交互式旋钮效果',
    preview: 'knob',
  },
];

export const functionCodes: FunctionCodes = {
  'clip-mask': `import React, { useRef, useEffect } from 'react'; 

const InteractiveImage = () => { 
  const containerRef = useRef(null); 
  const img2Ref = useRef(null); 
  const isUpdatingRef = useRef(false); 
  const boxValuesRef = useRef({ x: 0, y: 0, w: 0, h: 0 }); 

  const updateBoxValues = () => { 
    if (!containerRef.current) return; 
    const box = containerRef.current; 
    const rect = box.getBoundingClientRect(); 
    boxValuesRef.current = { 
      x: rect.left, 
      y: rect.top, 
      w: rect.width, 
      h: rect.height 
    }; 
  }; 

  const updateClipPath = (mouseX, mouseY) => { 
    if (!img2Ref.current) return; 

    const { x: boxX, y: boxY, w: boxW, h: boxH } = boxValuesRef.current; 
    const xPercent = ((mouseX - boxX) / boxW) * 200; 
    const yPercent = ((mouseY - boxY) / boxH) * 200; 

    img2Ref.current.style.clipPath = \` 
      polygon( 
        0% 0px, 
        100% 0%, 
        \${xPercent.toFixed(2)}% 0%, 
        0% \${yPercent.toFixed(2)}%, 
        0% 100% 
      ) 
    \`; 

    isUpdatingRef.current = false; 
  }; 

  const handleMouseMove = (e) => { 
    updateBoxValues(); 
    const mouseX = e.clientX; 
    const mouseY = e.clientY; 

    if (!isUpdatingRef.current) { 
      isUpdatingRef.current = true; 
      requestAnimationFrame(() => updateClipPath(mouseX, mouseY)); 
    } 
  }; 

  useEffect(() => { 
    const container = containerRef.current; 
    if (!container) return; 

    updateBoxValues(); 
    container.addEventListener('mousemove', handleMouseMove); 

    const handleResize = () => { 
      updateBoxValues(); 
    }; 
    window.addEventListener('resize', handleResize); 

    return () => { 
      container.removeEventListener('mousemove', handleMouseMove); 
      window.removeEventListener('resize', handleResize); 
    }; 
  }, []); 

  const containerStyle = { 
    width: '1080px', 
    height: '680px', 
    overflow: 'hidden', 
    margin: '100px auto', 
    position: 'relative', 
    borderRadius: '8px' 
  }; 

  const img1Style = { 
    width: '1080px', 
    height: '680px', 
    position: 'absolute', 
    zIndex: 1 
  }; 

  const img2Style = { 
    width: '1080px', 
    height: '680px', 
    position: 'absolute', 
    zIndex: 2, 
    clipPath: 'none', 
    transition: 'clip-path 0.1s ease' 
  }; 

  return ( 
    <div className="container" ref={containerRef} style={containerStyle}> 
      <img className="img2" ref={img2Ref} style={img2Style} src="/img/app_blacked2DCjThr-q.png" alt="" /> 
      <img className="img1" style={img1Style} src="/img/app_white2.png" alt="" /> 
    </div> 
  ); 
}; 

export default InteractiveImage;`,
  'knob': `import React, { useRef, useEffect, useState } from 'react';

const KnobEffect = () => {
  const knobRef = useRef(null);
  const [rotation, setRotation] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const calculateRotation = (clientX, clientY) => {
    if (!knobRef.current) return 0;
    const rect = knobRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const deltaX = clientX - centerX;
    const deltaY = clientY - centerY;
    let angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);
    if (angle < 0) angle += 360;
    return angle;
  };

  // ... 更多代码
};

export default KnobEffect;`,
};